<script setup lang="ts">
import { ref, onMounted } from 'vue'
import AccountPanelLegalMissingDataAlert from '../../components/account/legal/AccountPanelLegalMissingDataAlert.vue'
import { isLegalProfile } from '../investment-process/useUserProfileType'
import AccountPanelPersonalMissingDataAlert from '../../components/account/personal/AccountPanelPersonalMissingDataAlert.vue'
import { useLegalAccountDataState } from '../account/useAccountDataLegal'
import { usePersonalAccountDataState } from '../account/useAccountDataPersonal'

const modalOpen = ref(false)
const dataIsMissing = isLegalProfile()
    ? !useLegalAccountDataState().hasAllRequiredProfileAttributesForInvestment
    : !usePersonalAccountDataState().hasAllRequiredNaturalProfileAttributesForInvestment

onMounted(() => {
    let urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('new_registration') && urlParams.get('new_registration') === '1') {
        modalOpen.value = true
    }
})

function onboardingFlowEnabled(): boolean {
    return window.onboardingFlowEnabled ?? false
}

function closeIfOutside(e: object) {
    if (!window.document.querySelector('.modal-body').contains(e.target)) {
        modalOpen.value = false
    }
}
</script>

<template>
    <div
        v-if="modalOpen && dataIsMissing && onboardingFlowEnabled()"
        class="modal wrapper-fluid container-sm missing-data-modal"
        style="display: block"
        @click="closeIfOutside">
        <div class="modal-body relative mx-auto my-5 bg-white">
            <span
                class="modal-close close-round text-gray-dark align-self-end float-right"
                @click="modalOpen = false"></span>
            <div class="frontend-v2 py-3">
                <AccountPanelLegalMissingDataAlert v-if="isLegalProfile()" />
                <AccountPanelPersonalMissingDataAlert v-else />
            </div>
        </div>
    </div>
</template>

<style scoped></style>
